// styles for accept and reject buttons in dialogs for deleting objects in dashboard

export const acceptBtnStyle = {
  backgroundColor: 'white',
  border: '1px solid gray',
  fontSize: '11px',
  padding: '4px',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: 'red',
    color: 'white',
    border: '1px solid red',
  },
};

export const rejectBtnStyle = {
  backgroundColor: 'white',
  border: '1px solid gray',
  fontSize: '11px',
  padding: '4px',
  color: 'gray',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: 'gray',
    color: 'white',
  },
};
